import solanaLogo from "../assets/solana-logo.svg";
import avoMascot from "../assets/mascot/avoca-mascot.png";
import spaceman from "../assets/mascot/blurry-spaceman.png";
import cloudLeft from "../assets/bottom-left-cloud.png";
import cloudRight from "../assets/bottom-right-cloud.png";
import blurryCloud from "../assets/blurry-cloud.png";

export default function HeroSlide({ onNext }: { onNext: () => void }) {
  return (
    <>
      <div className="glow-point top-1/4 left-1/4" />

      {/* Atmospheric clouds - layered behind everything */}
      <img
        src={blurryCloud}
        alt=""
        className="absolute -top-10 -right-20 w-[75rem] opacity-30 pointer-events-none"
        style={{ filter: "hue-rotate(200deg) saturate(0.5)" }}
      />
      <img
        src={cloudLeft}
        alt=""
        className="absolute -bottom-32 -left-44 w-[87rem] opacity-15 pointer-events-none translate-y-1/3"
        style={{ filter: "hue-rotate(200deg) saturate(0.3)" }}
      />

      {/* Blurry spaceman - atmospheric depth element, top-left of right column */}
      <img
        src={spaceman}
        alt=""
        className="absolute top-[12%] right-[38%] w-56 opacity-65 pointer-events-none animate-float"
        style={{ animationDuration: "8s" }}
      />

      <div className="max-w-7xl w-full mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
        <div className="space-y-8">
          <div className="inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full border border-avo-teal/30 bg-avo-teal/10">
            <img src={solanaLogo} alt="Solana" className="w-4 h-4" />
            <span className="text-avo-teal text-sm font-pixel tracking-wider">LIVE ON SOLANA</span>
          </div>
          <h1 className="font-display text-8xl tracking-tight leading-[0.9]">
            The future of<br />
            <span className="text-gradient">Capital</span> is<br />
            Autonomous.
          </h1>
          <p className="text-2xl text-jacarta-300 max-w-lg leading-relaxed">
            Avo is the execution layer for intelligence in DeFi. We are moving from a world of manual trading to an economy of agents.
          </p>
          <div className="pt-4">
            <button
              onClick={onNext}
              className="px-8 py-4 bg-transparent text-avo-lime font-pixel text-xl tracking-widest cursor-pointer border-2 border-avo-lime/60 hover:bg-avo-lime/10"
            >
              ENTER THE ARENA ▶
            </button>
          </div>
        </div>

        {/* Right side - mascot scene */}
        <div className="relative h-[600px] w-full flex items-center justify-center translate-y-[28%] translate-x-[10%]">
          {/* Main mascot - cheerful avo */}
          <div className="relative">
            <img
              src={avoMascot}
              alt="Avo Mascot"
              className="w-[25rem] drop-shadow-[0_0_60px_rgba(158,255,0,0.2)]"
              style={{ animation: "gentle-bob 4s ease-in-out infinite" }}
            />
          </div>
        </div>
      </div>
      {/* Right cloud - in front of mascot */}
      <img
        src={cloudRight}
        alt=""
        className="absolute -bottom-56 -right-96 w-[100rem] opacity-100 pointer-events-none translate-y-1/3 z-20"
        style={{ filter: "hue-rotate(200deg) saturate(0.3) brightness(0.4)" }}
      />
    </>
  );
}
